export default __webpack_public_path__ + "static/media/static.054483ba.mp3";